<script setup>
import Product from '@/components/Product.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { strapiQuery } from '@/composables/strapiQuery'

const route = useRoute()

const query = computed(() => {
  let url =
    'api/products?pagination[pageSize]=100&populate[0]=image&sort[0]=category.name&sort[1]=name'
  if (route.query.category) {
    url += `&populate[1]=category&filters[category][$eq]=${route.query.category}`
  }
  return url
})

const { data: products, loading, error } = strapiQuery(query)

const title = computed(() => {
  if (route.query.category && products.value.length > 0) {
    const firstProduct = products.value[0]
    return firstProduct.category?.data?.name || 'Produkte'
  }
  return 'Produkte'
})
</script>

<template>
  <v-container fluid>
    <p class="text-h3 text-center text-primary mb-3">
      {{ title }}
    </p>
    <v-card class="mx-auto d-flex justify-center flex-wrap" max-width="900" border>
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-alert v-else-if="error" type="error" class="ma-4 w-100">
        Fehler beim Laden der Produkte. Bitte überprüfen Sie die Verbindung zum CMS.
      </v-alert>
      <template v-else>
        <Product
          v-for="product in products"
          :name="product.name"
          :description="product.description"
          :price="product.price"
          :img-url="product.image.formats.small.url"
          :key="product.id"
        />
      </template>
    </v-card>
  </v-container>
</template>
